/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Summary_Status_OpenInputs */



/**
* | output |
* | --- |
* | "Not yet invoiced · the month is still open" |
*
* @param {Partner_Summary_Status_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_status_open = /** @type {((inputs?: Partner_Summary_Status_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_Status_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht abgerechnet · der Monat läuft noch")
	return /** @type {LocalizedString} */ ("Not yet invoiced · the month is still open")
});